// extracted by mini-css-extract-plugin
export var actionText = "_nv-4";
export var container = "_nv-0";
export var leftSection = "_nv-1";
export var rightSection = "_nv-2";
export var settingsButton = "_nv-6";
export var settingsIcon = "_nv-7";
export var shortcut = "_nv-5";
export var shortcutGroup = "_nv-3";